var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stk-yourstake-icon"},[_c('img',{attrs:{"src":_vm.src,"alt":"YourStake Icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }